// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"529":"d556047f","620":"28edae49","860":"715f5b57"}[chunkId] + ".css";
};